import { HttpContextToken } from '@angular/common/http';

// Set on a request whose error the calling page shows itself.
export const HIDE_ERROR_TOAST = new HttpContextToken<boolean>(() => false);
